@if (citedSources().length > 0) {
  <app-activity-sources [id]="id()" [sources]="citedSources()" />
}

@if (sources().length > 0) {
  <app-activity-sources [id]="id()" [sources]="sources()" />
}

@for (message of messages(); track message.key; let i = $index) {
  <div [class.activity-message__has-sensitive-data]="message.sensitiveData">
    <div>{{ message.key }}</div>

    <div>
      @if (message.value && message.isCopyable) {
        <app-copy-button [value]="message.value" />
      }

      @if (message.iconPath) {
        <img class="icon" [src]="message.iconPath" />
      }

      @if (message.copyableText) {
        <div appLongTextTooltip>
          {{ message.copyableText }}
        </div>
      }

      @if (message.tooltipLabelPath && message.tooltipIconPath) {
        <div class="activity-message__tooltip-image">
          <span>
            {{ message.value }}
          </span>
          <img
            class="activity-message__icon-tooltip"
            [src]="message.tooltipIconPath"
            matTooltip="{{ message.tooltipLabelPath | labelsProvider }}"
          />
        </div>
      }

      @if (message.method) {
        <a class="activity-message__link" (click)="message.method()">
          {{ message.value }}
        </a>
      }

      @if (
        !message.copyableText &&
        !message.sensitiveData &&
        !message.tooltipIconPath &&
        !message.tooltipLabelPath &&
        !message.method
      ) {
        <div>
          {{ message.value }}
        </div>
      }

      @if (message.sensitiveData) {
        <app-sensitive-message-content [id]="id()" [sensitiveDataParams]="message.sensitiveData" />
      }
    </div>
  </div>
}

<span class="activity-message__timestamp">
  {{ timestamp() | date: 'HH:mm:ss' }}
</span>

@if (relatedFindings(); as relatedFindings) {
  <div class="separator"></div>

  <app-severities-cell
    [severities]="relatedFindings"
    [interactable]="true"
    (click)="findingsForActivityClicked.emit(id())"
  />
}
